import * as SliderPrimitive from '@radix-ui/react-slider'
import { cn } from '../../lib/cn'

function Slider({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>) {
  return (
    <SliderPrimitive.Root
      className={cn('relative flex items-center select-none touch-none w-full', className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1 grow rounded-full overflow-hidden bg-bg-active">
        <SliderPrimitive.Range className="absolute h-full bg-gradient-to-r from-accent to-accent-hover rounded-full" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          'block w-4 h-4 rounded-full bg-text-primary border-[2.5px] border-accent shadow-sm',
          'transition-all duration-fast',
          'hover:shadow-glow hover:scale-110',
          'focus:outline-none focus-visible:shadow-glow-strong'
        )}
      />
    </SliderPrimitive.Root>
  )
}

export { Slider }
